import styled from 'styled-components/macro'
import { Button as BootstrapButton } from 'reactstrap'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em;
`

const Heading = styled.h1`
  font-size: 2.5em;
  text-align: left;
`

const Message = styled.span``

const Button = styled(BootstrapButton)`
  margin-top: 2em;
  width: 100%;
`

const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 2em 0;
  & img {
    height: 5.4rem;
  }
`

export { Wrapper, Heading, Message, Button, ImageWrapper }
